<div class="container vw-100">
  <form [formGroup]="rawQuestionnaire" (ngSubmit)="onSubmit($event)">
    <div *ngFor="let question of rawQuestions; let i = index">
      <div
        class="card my-5 shadow"
        *ngIf="
          getQuestionVisibility(
            replaceSpace((question.questionID).toString() + '_' + question.question)
          )
        "
      >
        <div class="card-header">
          <h6 class="card-title whitespace">
            {{ question.question }}
          </h6>
        </div>
        <div class="card-body">
          <!-- likert scale -->
          <app-likert
            *ngIf="getType(question.type) === 'likert'"
            [form]="rawQuestionnaire"
            [controlName]="
              replaceSpace((question.questionID).toString() + '_' + question.question)
            "
            [labelLow]="question.minLabel"
            [labelHigh]="question.maxLabel"
            [rangeLow]="question.minRange"
            [rangeHigh]="question.maxRange"
          ></app-likert>
          <!-- multi-select -->
          <div
            *ngIf="['radio', 'checkbox'].includes(getType(question.type))"
            class="form-check"
          >
            <div
              *ngFor="let answer of question.answers"
              class="form-check"
              formGroupName="{{
                replaceSpace((question.questionID).toString() + '_' + question.question) +
                  '_Group'
              }}"
            >
              <input
                class="form-check-input"
                [type]="getType(question.type)"
                [id]="replaceSpace((question.questionID).toString() + '_' + answer)"
                [name]="
                  replaceSpace((question.questionID).toString() + '_' + question.question)
                "
                [value]="answer"
                formControlName="{{
                  replaceSpace((question.questionID).toString() + '_' + question.question)
                }}"
                (change)="
                  onMultiChange(
                    replaceSpace((question.questionID).toString() + '_' + question.question),
                    answer,
                    $event
                  )
                "
              />
              <label
                class="form-check-label"
                [for]="replaceSpace((question.questionID).toString() + '_' + answer)"
                >{{ answer }}</label
              >
            </div>
          </div>

          <!-- dropdown -->
          <div
            formGroupName="{{
              replaceSpace((question.questionID).toString() + '_' + question.question) +
                '_Group'
            }}"
          >
            <select
              *ngIf="getType(question.type) === 'select'"
              [name]="
                replaceSpace((question.questionID).toString() + '_' + question.question)
              "
              [id]="replaceSpace((question.questionID).toString() + '_' + question.question)"
              formControlName="{{
                replaceSpace((question.questionID).toString() + '_' + question.question)
              }}"
              class="form-control"
              (change)="
                onSelectChange(
                  replaceSpace((question.questionID).toString() + '_' + question.question),
                  $event
                )
              "
            >
              <option value="" disabled selected>
                {{ placeholderSelectAnswer }}
              </option>
              <option *ngFor="let answer of question.answers" [value]="answer">
                {{ answer }}
              </option>
            </select>
          </div>

          <!-- text -->
          <div
            formGroupName="{{
              replaceSpace((question.questionID).toString() + '_' + question.question) +
                '_Group'
            }}"
          >
            <input
              *ngIf="getType(question.type) === 'textarea'"
              type="textarea"
              class="form-control"
              [name]="
                replaceSpace((question.questionID).toString() + '_' + question.question)
              "
              [id]="replaceSpace((question.questionID).toString() + '_' + question.question)"
              formControlName="{{
                replaceSpace((question.questionID).toString() + '_' + question.question)
              }}"
              [placeholder]="placeholderText"
            />
          </div>

          <!-- number input -->
          <div
            formGroupName="{{
              replaceSpace((question.questionID).toString() + '_' + question.question) +
                '_Group'
            }}"
          >
            <input
              *ngIf="getType(question.type) === 'number'"
              type="number"
              class="form-control"
              [name]="
                replaceSpace((question.questionID).toString() + '_' + question.question)
              "
              [id]="replaceSpace((question.questionID).toString() + '_' + question.question)"
              [min]="question.minRange"
              [max]="question.maxRange"
              formControlName="{{
                replaceSpace((question.questionID).toString() + '_' + question.question)
              }}"
              [placeholder]="placeholderText"
            />
          </div>

          <!-- drag&drop -->
          <div
            *ngIf="
              getType(question.type) === 'drag&drop' ||
              getType(question.type) === 'drag&drop_selection'
            "
          >
            <app-drag-n-drop
              (rankingChange)="
                onRankingChange(
                  replaceSpace((question.questionID).toString() + '_' + question.question),
                  $event
                )
              "
              class="w-100 d-flex"
              [answerOptions]="question.answers"
              [useImages]="question.useImages"
              [question]="
                replaceSpace((question.questionID).toString() + '_' + question.question)
              "
            ></app-drag-n-drop>
          </div>

          <!-- slider -->
          <!-- TODO: might need to insert the raw HMTL instead of a component in order to easily change color of the slider if it has been touched -->
          <app-slider
            *ngIf="getType(question.type) === 'range'"
            [range]="[question.minRange, question.maxRange]"
            [label]="[question.minLabel, question.maxLabel]"
            (valueChange)="
              onSliderChange(
                replaceSpace((question.questionID).toString() + '_' + question.question),
                $event
              )
            "
            [form]="rawQuestionnaire"
            [controlName]="
              replaceSpace((question.questionID).toString() + '_' + question.question)
            "
          ></app-slider>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary mb-3"
      type="submit"
      [disabled]="!rawQuestionnaire.valid"
    >
      {{ submitButtonLabel }}
    </button>
  </form>
</div>
